import { ResetRoleClaimsType } from "../../types/Role";
import { post } from "../../utils/axios-config";
import { ROLES_RESET_CLAIMS } from "../../utils/constants";

export const resetRoleClaims = async (data: ResetRoleClaimsType) => await post<ResetRoleClaimsType, string>(ROLES_RESET_CLAIMS, data);